import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
export const CreditApi = {
  ListCreditTransaction: {
    useQuery: (dto: server.dto.PaginatedCreditTransactionInstruction, opts: UseQueryOptions<server.dto.ApiResponseWrapperWithRequest<server.dto.CreditTransaction[], server.dto.ListCreditTransactionFilters>>) => useQuery({
      queryKey: ["Credit.ListCreditTransaction", dto],
      queryFn: () => window.CoreApi.Credit.ListCreditTransaction(dto).then(r => r.data),
      ...opts
    }),
    getCacheKey: (dto: server.dto.PaginatedCreditTransactionInstruction) => ["Credit.ListCreditTransaction", dto]
  }, 
  ListCreditGrant: {
    useQuery: (dto: server.dto.PaginatedCreditGrantInstruction, opts: UseQueryOptions<server.dto.ApiResponseWrapperWithRequest<server.dto.CreditGrant[], server.dto.ListCreditGrantFilters>>) => useQuery({
      queryKey: ["Credit.ListCreditGrant", dto],
      queryFn: () => window.CoreApi.Credit.ListCreditGrant(dto).then(r => r.data),
      ...opts
    }),
    getCacheKey: (dto: server.dto.PaginatedCreditGrantInstruction) => ["Credit.ListCreditGrant", dto]
  }, 
  GetCreditAccountByClient: {
    useQuery: (dto: server.dto.GetCreditAccountByClientInstruction, opts: UseQueryOptions<server.dto.ApiResponseWrapper<server.dto.CreditAccount>>) => useQuery({
      queryKey: ["Credit.GetCreditAccountByClient", dto],
      queryFn: () => window.CoreApi.Credit.GetCreditAccountByClient(dto).then(r => r.data),
      ...opts
    }),
    getCacheKey: (dto: server.dto.GetCreditAccountByClientInstruction) => ["Credit.GetCreditAccountByClient", dto]
  }, 
  ConfigAutoReload: {
    useQuery: (dto: server.dto.ConfigAutoReloadCreditsInstruction, opts: UseQueryOptions<server.dto.ApiResponse>) => useQuery({
      queryKey: ["Credit.ConfigAutoReload", dto],
      queryFn: () => window.CoreApi.Credit.ConfigAutoReload(dto).then(r => r.data),
      ...opts
    }),
    getCacheKey: (dto: server.dto.ConfigAutoReloadCreditsInstruction) => ["Credit.ConfigAutoReload", dto]
  }, 
  PurchaseCredits: {
    useQuery: (dto: server.dto.PurchaseCreditsInstruction, opts: UseQueryOptions<server.dto.ApiResponse>) => useQuery({
      queryKey: ["Credit.PurchaseCredits", dto],
      queryFn: () => window.CoreApi.Credit.PurchaseCredits(dto).then(r => r.data),
      ...opts
    }),
    getCacheKey: (dto: server.dto.PurchaseCreditsInstruction) => ["Credit.PurchaseCredits", dto]
  }, 
  AddPromoCredits: {
    useQuery: (dto: server.dto.AddPromoCreditsInstruction, opts: UseQueryOptions<server.dto.ApiResponse>) => useQuery({
      queryKey: ["Credit.AddPromoCredits", dto],
      queryFn: () => window.CoreApi.Credit.AddPromoCredits(dto).then(r => r.data),
      ...opts
    }),
    getCacheKey: (dto: server.dto.AddPromoCreditsInstruction) => ["Credit.AddPromoCredits", dto]
  }, 

}
